import styled from 'styled-components';
import {textSizes, headingSizes} from '@stencil/build-theme';

export const MainWrapper = styled.div`
  border: 0.1rem solid transparent;
  background:
    linear-gradient(#fff, #fff) content-box,
    linear-gradient(
        95.22deg,
        rgba(140, 103, 28, 0.7) 0%,
        rgba(211, 170, 83, 0.7) 26.96%,
        rgba(255, 239, 207, 0.7) 56.52%,
        rgba(211, 170, 83, 0.7) 78.3%,
        rgba(140, 103, 28, 0.7) 101.62%
      )
      border-box;
  border-radius: 1.6rem;
  overflow: hidden;
  width: 120rem;
`;

export const InnerWrapper = styled.div`
  background: linear-gradient(0deg, #ffffff, #ffffff),
    linear-gradient(325.54deg, #fff6e5 5.22%, #ffffff 34.1%),
    linear-gradient(187.28deg, #fff6e5 -2.16%, rgba(255, 255, 255, 0) 19.31%, #ffffff 74.44%);
`;

export const TopWrapper = styled.div`
  padding: 2rem 2.4rem;
  display: flex;
  align-items: center;
  gap: 2rem;
  border-bottom: 0.1rem solid #e4e4e4;
`;

export const ElitePackageDesc = styled.p`
  ${textSizes.BaseW1};

  .boldText {
    ${textSizes.BaseW2};
  }
`;

export const ElitePackageTagWrapper = styled.div`
  border: 0.1rem solid transparent;
  background:
    linear-gradient(#fff, #fff) content-box,
    linear-gradient(94.77deg, #d3aa53 0%, #6b4905 100%) border-box;
  border-radius: 0.4rem;
  overflow: hidden;
  align-self: center;
  width: fit-content;
`;

export const ElitePackageTag = styled.p`
  background-image: linear-gradient(94.77deg, #d3aa53 0%, #6b4905 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  line-height: normal;
  ${textSizes.SmallW1};
  padding: 0.4rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
`;

export const ContentLeftWrapper = styled.div`
  width: 50rem;
  border-right: 0.1rem solid #e4e4e4;
  padding: 2rem 3.2rem;
`;

export const ContentMiddleWrapper = styled.div`
  width: 40rem;
  border-right: 0.1rem solid #e4e4e4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 6rem;
  padding: 1rem 0;
`;

export const ContentRightWrapper = styled.div`
  width: 30rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10rem;
`;

export const RoomTypeHeader = styled.h5`
  ${headingSizes.Base};
  color: #222222;
  margin-bottom: 1.5rem;
`;

export const PaxInfo = styled.p`
  ${textSizes.BaseW1};
  color: #717171;
  margin-bottom: 1.6rem;
`;

export const RoomInfoWrapper = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const RoomImg = styled.img`
  width: 14rem;
  height: 10rem;
  border-radius: 1.6rem;
  object-fit: cover;
`;

export const RoomFeatureHeader = styled.h5`
  ${textSizes.BaseW3};
  color: #222222;
  margin-bottom: 0.8rem;
`;

export const FeaturesList = styled.ul``;

export const FeaturesListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin-bottom: 0.8rem;
`;

export const ViewMoreCta = styled.a`
  ${textSizes.BaseW2};
  color: #2276e3;
  margin-top: 3px;
`;

export const ElitePackageFeatureIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const ElitePackageFeatureDesc = styled.p`
  ${textSizes.BaseW1};
  color: #222;
`;

export const RoomPrice = styled.p`
  ${textSizes.SmallW1};
  color: #717171;
  text-decoration: line-through;
  margin-bottom: 0.2rem;
`;

export const OfferPrice = styled.p`
  ${textSizes.LargeW3};
  color: #222;
  margin-bottom: 0.2rem;
`;

export const TaxText = styled.p`
  ${textSizes.SmallW1};
  color: #222;
  margin-bottom: 0.2rem;
`;

export const BNPLCta = styled.div`
  ${textSizes.SmallW1};
  color: #2276e3;
`;

export const SelectRoomBtn = styled.button`
  outline: none;
  border: 0.15rem solid #ff6d38;
  border-radius: 0.6rem;
  color: #ff6d38;
  ${textSizes.SmallW2};
  background: #fff;
  padding: 1rem 1.6rem;
  margin-top: 1.5rem;
  width: 12.4rem;
  cursor: pointer;
`;

export const RoomInfoLeftWrapper = styled.div`
  align-self: flex-end;
`;

export const RoomInfoList = styled.ul``;

export const RoomInfoListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1rem;
  > img {
    width: 1.6rem;
  }
`;

export const RoomInfoListItemDesc = styled.p`
  ${textSizes.SmallW1};
  color: #222222;
`;

export const MoreInfoCta = styled.a`
  ${textSizes.SmallW2};
  color: #2276e3;
`;

export const ButtonWrapper = styled.div``;
